// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__33Rpf","notes":"Notes_notes__2hzBh"};